import React, { useEffect } from 'react'
import Navbar from 'src/components/Navbar/Navbar'
import Footer from 'src/components/Footer/Footer'
import PostGraduationContent from 'src/components/PostGraduationContent/PostGraduationContent'

const ListPostGraduate = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Navbar />
      <PostGraduationContent />
      <Footer />
    </>
  )
}

export default ListPostGraduate
